import * as React from 'react'
import { MouseEvent, ReactElement } from 'react'
import { ActionButton, BaseButton, DialogFooter, IButtonProps, PrimaryButton } from '@fluentui/react'
import { Dismiss } from '../Dialog/Command/CommandDialog'

export type CommandButtonProps<V = undefined> = Omit<IButtonProps, 'onClick'> & {
    onClick?: DismissEventHandler<V>
}

export type CommandButtonsProps<V = undefined> = {
    dismiss: Dismiss
    getValues?: () => V
    primaryButton?: boolean
    primaryButtonProps?: CommandButtonProps
    dismissButton?: boolean
    dismissButtonProps?: CommandButtonProps
}

type DismissEventHandler<V = undefined> = (dismiss: Dismiss, values: V, event: MouseEvent<BaseButton>) => void

export default function CommandButtons<V = undefined>(props: CommandButtonsProps<V>): ReactElement {
    const dismissHandler = (eventHandler: DismissEventHandler<V>) => (event: MouseEvent<BaseButton>) => {
        // Prevent the default Formik event handler from adding form values to the URL which results in a reset
        // in Outlook.
        event.preventDefault()

        if (eventHandler) {
            eventHandler(props.dismiss, props.getValues?.(), event)
        } else {
            props.dismiss()
        }
    }

    return (
        <DialogFooter>
            {(props.dismissButton || props.dismissButtonProps) && (
                <ActionButton
                    text="Sluiten"
                    {...props.dismissButtonProps}
                    onClick={dismissHandler(props.dismissButtonProps?.onClick)}
                />
            )}
            {(props.primaryButton || props.primaryButtonProps) && (
                <PrimaryButton
                    text="Opslaan"
                    type="submit"
                    {...props.primaryButtonProps}
                    onClick={dismissHandler(props.primaryButtonProps?.onClick)}
                />
            )}
        </DialogFooter>
    )
}
